import * as React from "react"

import { cn } from "@/lib/utils"
import * as PropTypes from 'prop-types'

import { INPUT_FIELD_ERROR_CLASSNAME } from "@/constants/classname/classname";

export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  hasError?: boolean;
}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, hasError, ...props }, ref) => {
    return (
      <textarea
        className={cn(
          // text-primary added 2026-04-28 — CEO flagged the chat input on
          // /dashboards/new was rendering typed text white-on-light-gray
          // (WCAG AA contrast violation). Mirrors the parallel fix to
          // ui/input.tsx for the manual paste modal.
          "flex h-[240px] w-full rounded-md border border-input bg-background px-3 py-2 text-sm text-primary ring-offset-background placeholder:text-muted focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-focusRing focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
          className,
          hasError ? INPUT_FIELD_ERROR_CLASSNAME : ''
        )}
        ref={ref}
        {...props}
      />
    )
  }
)

Textarea.propTypes = {
  className: PropTypes.string,
  hasError: PropTypes.bool
}

Textarea.displayName = "Textarea"

export { Textarea }
